import { render } from "./InspectionReport.vue?vue&type=template&id=4cd2ffd4&scoped=true"
import script from "./InspectionReport.vue?vue&type=script&lang=js"
export * from "./InspectionReport.vue?vue&type=script&lang=js"

import "./InspectionReport.vue?vue&type=style&index=0&id=4cd2ffd4&lang=scss&scoped=true"

import exportComponent from "/Users/liming/jenkins/jenkins/workspace/an-plus-frontend-monorepo-prod/projects-mobile/property/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cd2ffd4"]])

export default __exports__